import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';
import SelectList from './SelectList.vue';
import { HlaseniOSkode } from './hlaseniOSkode';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList }, CRUMB_LABEL_KEY),
	HlaseniOSkode.router,
]);
